export default function(num) {
  if (typeof num === "number") return num.toLocaleString();
}
